import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { MODAL_CLOSE } from 'redux/slices/modals';
import moment from 'moment';
import { Button, DateRange, Icon } from 'ui/atoms';
import { Container } from 'ui/gridSystem';

import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';

import {
  ButtonsContainer,
  ButtonWrapper,
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';
import { Period, PeriodDrodDown, CenterText } from './style';
import { DOWNLOAD_USERS_LIST } from '../../../../redux/sagas/actions/people';
import { DOWNLOAD_LEAD_LIST } from 'redux/sagas/actions/lead';
const modalId = 'DownloadReportModal';

const DownloadReportModal = ({
  onClose,
  charging_meta,
  downloadUsersList,
  downloadLeadFile,
  isLead
}) => {
  const { t } = useTranslation();
  const [filters, setFilter] = useState({});

  const handleSetFilter = (name, val) => {
    setFilter({ ...filters, [name]: val });
  };

  const handleDownloadData = () => {
    isLead ? downloadLeadFile(filters) : downloadUsersList(filters);
    setFilter({});
  };

  useEffect(() => {
    if (isLead) {
      setFilter({
        period: {
          startDate: moment()
            .subtract(30, 'days')
            .toDate(),
          endDate: moment().toDate(),
          key: 'selection'
        }
      });
    }
  }, [isLead]);

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="791px"
            height="744px"
          >
            <ModalTitle>
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {t('download_report')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <Period>
              <div>
                {isLead ? (
                  <CenterText>
                    <MainFont
                      type="peopleModalText"
                      configuration={{ fontSize: 16 }}
                    >
                      {t('select_period_lead')}
                    </MainFont>
                  </CenterText>
                ) : (
                  <CenterText>
                    <MainFont
                      type="4"
                      configuration={{ fontSize: 16, lineHeight: 2 }}
                    >
                      {t('select_period')}
                    </MainFont>
                  </CenterText>
                )}
              </div>
              <PeriodDrodDown>
                <DateRange
                  placeholder={t('select_period')}
                  values={
                    isLead
                      ? [
                          moment()
                            .subtract(30, 'days')
                            .toDate(),
                          moment().toDate()
                        ]
                      : null
                  }
                  onChange={val => handleSetFilter('period', val)}
                  splitted
                />
              </PeriodDrodDown>
            </Period>

            <ButtonsContainer>
              <ButtonWrapper>
                <Button variant="people-buttons" onClick={onClose}>
                  {t('cancel')}
                </Button>
              </ButtonWrapper>
              <ButtonWrapper>
                <Button
                  variant="accept-button"
                  onClick={handleDownloadData}
                  disabled={
                    (!isLead && !filters?.period) ||
                    (!isLead && filters?.period.length < 2)
                  }
                >
                  {t('download')}
                </Button>
              </ButtonWrapper>
            </ButtonsContainer>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

DownloadReportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  charging_meta: PropTypes.object,
  downloadUsersList: PropTypes.func,
  downloadLeadFile: PropTypes.func,
  isLoadingDataDownload: PropTypes.bool,
  isLead: PropTypes.bool
};

DownloadReportModal.id = modalId;

export default connect(
  state => ({}),
  dispatch => ({
    onClose: () => dispatch(MODAL_CLOSE()),
    downloadUsersList: payload =>
      dispatch({ type: DOWNLOAD_USERS_LIST._REQUEST, payload }),
    downloadLeadFile: payload =>
      dispatch({ type: DOWNLOAD_LEAD_LIST._REQUEST, payload })
  })
)(DownloadReportModal);
